import request from '@/utils/request'
import apiConfig from '@/api/apiconfig'
// 登录
export function liaoNingLogin(data) {
  return request({
    url: `${apiConfig.ZY}/liaoNingH5/login?param=${data.param}`,
    method: 'post',
    // custom: true
    // data
  })
}
// 下单
export function liaoNingPlace(data) {
  return request({
    url: `${apiConfig.ZY}/liaoNingH5/place`,
    token: sessionStorage.getItem('liaoningHighwayToken'),
    method: 'post',
    data
  })
}
// 分页
export function liaoNingList(data) {
  return request({
    url: `${apiConfig.ZY}/liaoNingH5/pageCodes`,
    token: sessionStorage.getItem('liaoningHighwayToken'),
    method: 'post',
    data
  })
}
// 详情
export function liaoNingDetail(data) {
  return request({
    url: `${apiConfig.ZY}/liaoNingH5/getCodeDetail?subOrderNo=${data.subOrderNo}`,
    token: sessionStorage.getItem('liaoningHighwayToken'),
    method: 'post'
    // data
  })
}
